/**
 * GA4 `user_id` for the current customer handle, or `undefined` when nothing should be pushed.
 * Per Google's User-ID guide: guests stay unset, sign-out sends `null`, never "" or "null".
 */
export function resolveGtmUserId(handle: string | null | undefined, hadUserId: boolean): string | null | undefined {
  const userId = normalizeCustomerHandle(handle)
  if (userId)
    return userId
  return hadUserId ? null : undefined
}

function normalizeCustomerHandle(handle: string | null | undefined): string | null {
  const trimmed = handle?.trim()
  if (!trimmed || trimmed.toLowerCase() === 'null')
    return null
  return trimmed
}
